import type { Tenant } from '../types';

export const TENANTS: Tenant[] = [
  {
    id: 'test-tenant-id',
    name: 'Test Company',
    logo: 'https://picsum.photos/id/20/40',
    primaryColor: '#3b82f6', // Bright Blue
    secondaryColor: '#6366f1',
  },
  {
    id: 'marion-tenant-id',
    name: 'Marion Companies',
    logo: 'https://picsum.photos/id/40/40',
    primaryColor: '#3b82f6', // Bright Blue
    secondaryColor: '#6366f1',
    domains: [
      {
        id: 'domain-libertas',
        name: 'Libertas',
        primaryColor: '#3b82f6'
      },
      {
        id: 'domain-aegis',
        name: 'Aegis',
        primaryColor: '#3b82f6'
      },
      {
        id: 'domain-salt-collective',
        name: 'Salt Collective',
        primaryColor: '#3b82f6'
      }
    ]
  }
];

export const DEFAULT_TENANT = TENANTS[1]; // Marion Companies by default
